var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16SearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 15.0417L11.7667 11.7667M7.79167 13.5C10.9433 13.5 13.5 10.9433 13.5 7.79167C13.5 4.64004 10.9433 2.08334 7.79167 2.08334C4.64004 2.08334 2.08333 4.64004 2.08333 7.79167C2.08333 10.9433 4.64004 13.5 7.79167 13.5Z",
    stroke: "#171717",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16SearchIcon);
export default __webpack_public_path__ + "static/media/kbv-v16-search-icon.a371c745d67fa11c464013e8a66e3357.svg";
export { ForwardRef as ReactComponent };